import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search as searchSkillMatrix } from 'services/skill-matric-services/smSkillMatrixService';
import PropTypes from 'prop-types';
import SkillMatrixTable from './SkillMatrixTable';
import { getMaxtrixUsers } from 'services/userServices';
import SkillMatrixTableHeader from './SkillMatrixTableHeader';
const RunningSkillMatrix = () => {
  const defaultRQ = { ...new BaseTableRQ(1, 2147483647)};
  const [ogiginSkillMatrix, setOginginSkillMatrixs] = useState([]);
  const [skillMatrixs, setSkillMatrixs] = useState([]);
  const [paging, setPaging] = useState({ ...defaultRQ});
  const [isFilter, setIsFilter] = useState(false);
  const [searchUIParam, setSearchUIParam] = useState({});

  useEffect(() => {
    setIsFilter(false);
  }, []);

  const searchUI = ({ keyword, department }) => {
    console.log(keyword, department);
    let searchData = ogiginSkillMatrix;
    console.log(keyword);
    if (keyword) {
      searchData = searchData.filter(i =>
        i.name.toLowerCase().includes(keyword.toLowerCase())
      );
    }
    console.log(department);
    if (department) {
      searchData = searchData.filter(
        i => i.departmentId.toString() == department.id.toString()
      );
    }

    setSkillMatrixs(searchData);
  };

  useEffect(() => {
    loadSkillMatrix(defaultRQ);
  }, []);

  const loadSkillMatrix = async pagingRq => {
    const res = await searchSkillMatrix(pagingRq);
    const usersRes = await getMaxtrixUsers();
    const data = usersRes.map(u => {
      let rs = { ...u, trainee: u.userId };
      const items = res.items.filter(i => i.trainee == u.userId);
      if (items.length > 0) {
        items.forEach(x => {
          rs[x.areaId?.toString()] = x.level;
          rs[x.areaId?.toString() + "_status"] = x.status;
          rs[x.areaId?.toString() + "_source"] = x.source;
        });
      }
      return rs;
    });

    setOginginSkillMatrixs(data);
    setSkillMatrixs(data);
    setPaging(pagingRq);
    console.log(data)
  };

  return (
    <Card>
      <Row style={{ padding: '10px' }}>
        <SkillMatrixTableHeader
          handleChange={(key, value) => {
            console.log(key, value);
            const uiParam = { ...searchUIParam, [key]: value };
            console.log(uiParam);
            setSearchUIParam(uiParam);
            searchUI(uiParam);
          }}
          style={{ padding: '10px' }}
        />
        <Col lg={isFilter ? 9 : 12}>
          <SkillMatrixTable
            data={skillMatrixs}
            paging={paging}
            total={0}
            nextPage={() => {}}
            previousPage={() => {}}
            gotoPage={() => {}}
          />
        </Col>
      </Row>
    </Card>
  );
};

RunningSkillMatrix.propTypes = {
  meetingId: PropTypes.string
};

export default RunningSkillMatrix;
